// 报名页api

import axios from "../utils/fetch";

// 获取老师类型数据
export const getPartTimeTeaTypeEnum = options => {
  const url = "/api/zmbiz-teacher-h5-api/api/teacher/h5/registration/partTimeTeaTypeEnum";
  return axios.getSign(url, options);
};

// 获取学科学段和学校数据
export const getTeacherEntryConfig = options => {
  const url = "/api/zmbiz-teacher-h5-api/api/teacher/h5/registration/getTeacherEntryConfigV2";
  return axios.postSign(url, options);
};

export const getReferrerMobile = options => {
  const url = "/api/zmbiz-teacher-h5-api/api/teacher/h5/registration/getReferrerMobile";
  return axios.getSign(url, options);
};

export const getReferrerMobileByAgentId = options => {
  const url = "/api/zmbiz-teacher-h5-api/api/teacher/h5/registration/getReferrerMobileByAgentId";
  return axios.getSign(url, options);
};

export const register = options => {
  const url = "/api/zmbiz-teacher-h5-api/api/teacher/h5/registration/register";
  return axios.postSign(url, options);
};

export const sendCode = options => {
  const url = "/api/zmbiz-teacher-h5-api/weChatBind/sendVerificateCode";
  return axios.postSign(url, options);
};

export const validateVerifyCode = options => {
  const url = "/api/zmbiz-teacher-h5-api/api/teacher/h5/registration/validateVerifyCode";
  return axios.postSign(url, options, true);
};

export const weChatQRCode = options => {
  const url = "/api/zmbiz-teacher-h5-api/weChatBind/weChatQRCode";
  return axios.post(url, options);
};

export const getQRC = () => {
  const url = "/api/zmbiz-teacher-h5-api/api/teacher/h5/registration/getQRC";
  return axios.getSign(url, {});
};

export const getMatchedChoolsByText = options => {
  const url = "/api/zmbiz-teacher-h5-api/api/teacher/h5/registration/getTSchool";
  return axios.getSign(url, options);
};
